import React, { useEffect, useMemo } from 'react';
import MemeVideoTableList from '../MemeVideoTable';
import { useMemeDetailsVideoList } from '@opm/pages/Memes/hooks';
import { getChartTimeParams } from '@op/utils/time';

interface IMemeVideoWrapperProps {
  detailsFilter: any;
  selectedKol: {
    anchor_uid: string;
    anchor_name: string;
  }[];
  setSelectedKol: (
    kols: {
      anchor_uid: string;
      anchor_name: string;
    }[],
  ) => void;
  wholePageRef: React.RefObject<HTMLDivElement>;
  selectedDate?: string;
}

export default function MemeVideoWrapper(props: IMemeVideoWrapperProps) {
  const { detailsFilter, selectedKol, setSelectedKol, wholePageRef, selectedDate } = props;

  const filter = useMemo(() => {
    return {
      ...detailsFilter,
      anchor_uids: selectedKol?.map((kol) => kol.anchor_uid) || [],
      ...(selectedDate ? getChartTimeParams(selectedDate, 'daily') : {}),
    };
  }, [detailsFilter, selectedKol, selectedDate]);

  const {
    nextPage,
    resetData,
    operation,
    loading,
    loadingRef,
    ...restVideoProps
  } = useMemeDetailsVideoList({
    filter,
  });

  useEffect(() => {
    const container = wholePageRef?.current;
    if (!container) return;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const isBottom = scrollTop + clientHeight >= scrollHeight - 20;
      if (isBottom && !loadingRef?.current) {
        nextPage();
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [wholePageRef, nextPage]);

  return (
    <MemeVideoTableList
      operation={operation}
      selectedKol={selectedKol}
      setSelectedKol={setSelectedKol}
      loading={loading!}
      {...restVideoProps}
    />
  );
}
